/** CONFIRMATION DE PRÉSENCE — un seul geste, depuis l'e-mail de rappel. */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { Check, X } from "lucide-react";
import { api, messageErreur } from "../api";
import { Btn, Micro, Squelette, Vide } from "../components/Bits";

export default function Confirmation() {
  const { token } = useParams();
  const [rdv, setRdv] = useState(null);
  const [erreur, setErreur] = useState(null);
  const [resultat, setResultat] = useState(null);
  const [envoi, setEnvoi] = useState(false);

  useEffect(() => {
    api
      .get(`/public/confirmation/${token}`)
      .then(({ data }) => {
        setRdv(data);
        if (data.confirme) setResultat("confirme");
      })
      .catch((e) => setErreur(messageErreur(e, "Ce lien n'est plus valable.")));
  }, [token]);

  const agir = async (action) => {
    setEnvoi(true);
    try {
      const { data } = await api.post(`/public/confirmation/${token}`, { action });
      setResultat(data.statut);
    } catch (e) {
      toast.error(messageErreur(e));
    } finally {
      setEnvoi(false);
    }
  };

  if (erreur)
    return (
      <div className="min-h-screen bg-[var(--paper)] flex items-center justify-center pad">
        <Vide titre="Lien expiré" texte={erreur} />
      </div>
    );

  if (!rdv)
    return (
      <div className="min-h-screen bg-[var(--paper)] pad pt-20">
        <div className="max-w-[440px] mx-auto">
          <Squelette lignes={2} />
        </div>
      </div>
    );

  return (
    <div className="min-h-screen bg-[var(--paper)] pad py-16">
      <div className="max-w-[440px] mx-auto surface rounded-[4px] p-7" data-testid="page-confirmation">
        <Micro>{rdv.activite}</Micro>
        <h1 className="display text-[24px] mt-3">
          {resultat === "confirme"
            ? "Merci, c'est confirmé"
            : resultat === "annule"
            ? "Rendez-vous annulé"
            : `Bonjour ${rdv.prenom || ""}`}
        </h1>

        <div className="border-y border-[var(--rule)] my-5 py-4">
          <p className="text-[15px]">
            {rdv.prestation} · <span className="first-letter:uppercase">{rdv.jour_label}</span> à{" "}
            <span className="num">{rdv.heure}</span>
          </p>
          {rdv.adresse && <p className="text-[13px] text-[var(--ink-soft)] mt-1">{rdv.adresse}</p>}
        </div>

        {rdv.passe ? (
          <p className="text-[14px] text-[var(--ink-soft)]">Ce rendez-vous est déjà passé.</p>
        ) : resultat === "confirme" ? (
          <p className="text-[14px] text-[var(--olive)] font-semibold">
            À très vite. Ton créneau est bloqué.
          </p>
        ) : resultat === "annule" ? (
          <p className="text-[14px] text-[var(--ink-soft)]">
            C'est noté, ton créneau est libéré. Merci de l'avoir signalé — ça permet à
            quelqu'un d'autre d'en profiter.
          </p>
        ) : (
          <div className="space-y-2">
            <Btn
              taille="lg"
              icone={Check}
              className="w-full"
              onClick={() => agir("confirme")}
              charge={envoi}
              data-testid="btn-confirmer-presence"
            >
              Je confirme ma présence
            </Btn>
            <Btn
              variante="danger"
              icone={X}
              className="w-full"
              onClick={() => agir("annule")}
              charge={envoi}
              data-testid="btn-annuler-presence"
            >
              Je ne pourrai pas venir
            </Btn>
          </div>
        )}
      </div>
    </div>
  );
}
